// Referencias al elemento HTML
const textEl = document.getElementById("dynamic-text");

// La lista de frases (las mantengo igual)
const phrases = [
  "lo hace.",
  "lo hace fácil.",
  "lo hace rápido.",
  "lo hace con IA.",
  "lo hace mejor.",
"lo hace con Selerian."
];

// Variables de control
let phraseIndex = 0; // Qué frase estamos escribiendo
let charIndex = 0;   // Qué letra de la frase estamos escribiendo
let isDeleting = false; // Estado: ¿Estamos escribiendo o borrando?

// Configuración de tiempos (en milisegundos)
const typeSpeed = 100;    // Velocidad al escribir cada letra
const deleteSpeed = 50;   // Velocidad al borrar (más rápido)
const pauseEnd = 1500;    // Cuánto tiempo se queda la frase completa antes de borrar
const pauseStart = 500;   // Cuánto tiempo espera antes de empezar a escribir la siguiente frase

// Función principal recursiva
function type() {
  const currentPhrase = phrases[phraseIndex];
  
  // Determinar qué parte de la frase mostrar
  if (isDeleting) {
    // Si estamos borrando, mostramos un caracter menos
    textEl.textContent = currentPhrase.substring(0, charIndex - 1);
    charIndex--;
  } else {
    // Si estamos escribiendo, mostramos un caracter más
    textEl.textContent = currentPhrase.substring(0, charIndex + 1);
    charIndex++;
  }

  // Lógica de pausa y cambio de estado
  let dynamicDelay = isDeleting ? deleteSpeed : typeSpeed;

  // Si terminó de escribir la frase completa
  if (!isDeleting && charIndex === currentPhrase.length) {
    isDeleting = true;
    dynamicDelay = pauseEnd; // Hacemos una pausa larga al final
  } 
  // Si terminó de borrar la frase completa
  else if (isDeleting && charIndex === 0) {
    isDeleting = false;
    phraseIndex++; // Pasamos a la siguiente frase de la lista
    
    // Si llegamos al final de la lista, reiniciamos el ciclo
    if (phraseIndex === phrases.length) {
      phraseIndex = 0;
    }
    dynamicDelay = pauseStart; // Pequeña pausa antes de empezar a escribir la nueva
  }

  // Llamada recursiva: ejecutamos esta función otra vez después del delay determinado
  setTimeout(type, dynamicDelay);
}

// Arrancamos el efecto por primera vez
// Usamos DOMContentLoaded para asegurar que el HTML esté cargado antes de correr el JS
document.addEventListener("DOMContentLoaded", type);